// Public site settings (contact + social details). No auth required.
import apiClient from './apiClient.js';

export const getPublicSiteSettings = () =>
  apiClient.get('/site-settings/public');
